import React, {Component} from 'react';
import Action from 'components/organisms/competition-stacking/actions';
import {connect} from 'react-redux';

class RemoveStackItem extends Component {
    onClick(itemId) {
        this.props.dispatch(Action.do('removeItemOfCompetitionStacking', itemId));
    }

    render() {
        const {itemId, children} = this.props;
        return (
            <span onClick={() => ::this.onClick(itemId)} className="close-rule">
                {children}
            </span>
        );
    }
}

export default connect(() => ({}))(RemoveStackItem);
